import GameInstructions from "../../components/GameInstructions/GameInstructions";
import Layout from "../../components/Layout/Layout";

const BlendingGameInstructions = () => {
  return (
    <Layout requiresAuth={true}>
      <GameInstructions game="blending" />
    </Layout>
  );
};

export default BlendingGameInstructions;
